var map = {
	"./template-1/results/results": "app/styles/client/templates/template-1/results/results",
	"./template-10/results/results": "app/styles/client/templates/template-10/results/results",
	"./template-11/results/results": "app/styles/client/templates/template-11/results/results",
	"./template-2/results/results": "app/styles/client/templates/template-2/results/results",
	"./template-3/results/results": "app/styles/client/templates/template-3/results/results",
	"./template-4/results/results": "app/styles/client/templates/template-4/results/results",
	"./template-5/results/results": "app/styles/client/templates/template-5/results/results",
	"./template-6/results/results": "app/styles/client/templates/template-6/results/results",
	"./template-7/results/results": "app/styles/client/templates/template-7/results/results",
	"./template-8/results/results": "app/styles/client/templates/template-8/results/results",
	"./template-9/results/results": "app/styles/client/templates/template-9/results/results"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3069;